import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare let $: any;
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
//FOR LANGUAGE CONVERSION - STARTS (FOR TOGGLING LANGUAGE CONVERSION)
import { TranslateService } from '@ngx-translate/core';
import { CustomServiceService } from '../../service/custom-service.service';
//FOR LANGUAGE CONVERSION - ENDS
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private route: Router, private encDec: EncryptDecryptService, public translate: TranslateService) {

    //FOR LANGUAGE CONVERSION - STARTS - SETTING IN LOCALESTORAGE
    translate.addLangs(['English', 'Hindi']);
    if (!sessionStorage.getItem('locale')) {
      sessionStorage.setItem('locale', 'Hindi');
    }
    //FOR LANGUAGE CONVERSION - ENDS - SETTING IN LOCALESTORAGE
  }

  //For Language conversion
  language: any = "";

  //FONT SIZE VARIABLES START
  fontSize: number = 16;
  clickLimit: number = 3;
  clickCountIncrease: number = 0;
  clickCountDecrease: number = 0;

  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  zoneurl: any = environment.zoneURL;
  regionURL: any = environment.regionURL;
  datetime: any = this.httpservice.currentDateTime();
  query_param: any;
 
  env:any = environment;
  //
  menutimeInteval:any = null; 
  ZoneRegionNameTime:any=null;
  ngOnInit(): void {

    // Retrieve values from local storage or use default values
    this.fontSize = parseInt(localStorage.getItem('fontSize') || '16', 10);
    this.clickCountIncrease = parseInt(localStorage.getItem('clickCountIncrease') || '0', 10);
    this.clickCountDecrease = parseInt(localStorage.getItem('clickCountDecrease') || '0', 10);

    // Apply initial font size
    this.updateFontSize();

    this.menutimeInteval = setInterval(():any=>{
      if(!this.fciwebservice.MenuData().progress){
        this.getallHeaderMenu();
        clearInterval(this.menutimeInteval);
      }
    }, 500);

    this.ZoneRegionNameTime = setInterval(():any=>{
      if(!this.fciwebservice.ZoneRegionNameData().progress){
        this.getZoneRegionName();
        clearInterval(this.ZoneRegionNameTime);
      }
    }, 500);
    // for chatbot wrapper button
    const toggleButton = $('.fab-btn');
    toggleButton.click(function () {
      $('body').addClass('overflow-hidden');
    });
    // for chatbot wrapper close button
    const toggleCloseButton = $('.fab-btn-close');
    toggleCloseButton.click(function () {
      $('body').removeClass('overflow-hidden');
    });

    // if(window.localStorage.getItem('locale')==null){
    //   this.translate.use('English');
    // }
    //FOR LANGUAGE CONVERSION - STARTS - FOR SETTING STATIC AND DYNAMIC LANGUAGE
    this.language = sessionStorage.getItem('locale');//dynamic
    this.translate.use(this.language);//static
    //FOR LANGUAGE CONVERSION - ENDS - FOR SETTING STATIC AND DYNAMIC LANGUAGE


    if (this.route.url.replace('/', "") !== 'contentsearch') {
      window.localStorage.removeItem('search_key');
    }
    if (window.localStorage.getItem('search_key')) {
      this.query_param = window.localStorage.getItem('search_key');
    } else {
      this.query_param = "";
    }
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);

    Aos.init();


    // SKIP TO MAIN CONTENT - STARTS
    // $('#skipContent').click(function () {
    //   $('app-whats-new').attr('tabindex', -1).focus();
    // });

    // SKIP TO MAIN CONTENT - ENDS

    //FOR MEGAMANU - STARTS
    document.addEventListener("DOMContentLoaded", () => {
      // Prevent closing from click inside dropdown
      document.querySelectorAll('.dropdown-menu').forEach((element: Element) => {
        element.addEventListener('click', (e: Event) => {
          e.stopPropagation();
        });
      });
    });
    //FOR MEGAMANU - ENDS

    // for hiding elements on scroll
    const widthScreen = $(window).width();
    this.scroll(widthScreen);



    //SWITCH THEME - STARTS (Added By Vishal)
    $('.logo-dark').show();

    if (localStorage.getItem('theme') === 'theme-dark') {
      this.setTheme('theme-dark');
      $('#slider').prop("checked", true);
      $('.logo-light').show();
      $('.logo-dark').hide();

    } else {
      this.setTheme('theme-light');
      $('#slider').prop("checked", false);
      $('.logo-dark').show();
      $('.logo-light').hide();
    }
    //SWITCH THEME - ENDS
  }

  //FONT SIZE VARIABLES END
  //FONT SIZE START
  private updateFontSize() {
    $('.font-adjust').css({ "font-size": this.fontSize + 'px' });
  }

  private saveToLocalStorage() {
    // Save values to local storage
    localStorage.setItem('fontSize', this.fontSize.toString());
    localStorage.setItem('clickCountIncrease', this.clickCountIncrease.toString());
    localStorage.setItem('clickCountDecrease', this.clickCountDecrease.toString());
  }

  increaseFontSize() {
    if (this.clickCountIncrease < this.clickLimit) {
      this.fontSize++;
      this.clickCountIncrease++;

      this.updateFontSize();
      this.saveToLocalStorage();
    }
  }

  decreaseFontSize() {
    if (this.clickCountDecrease < this.clickLimit) {
      this.fontSize--;
      this.clickCountDecrease++;

      this.updateFontSize();
      this.saveToLocalStorage();
    }
  }

  resetFontSize() {
    // Reset values
    this.fontSize = 16;
    this.clickCountIncrease = 0;
    this.clickCountDecrease = 0;

    this.updateFontSize();
    
    // Clear data from local storage
    localStorage.removeItem('fontSize');
    localStorage.removeItem('clickCountIncrease');
    localStorage.removeItem('clickCountDecrease');
  }
  //FONT SIZE END


  // bilangual started
  changeLang(language: any) {
    if (sessionStorage.getItem('locale') != null) {
      sessionStorage.removeItem('locale');
    }
    this.translate.use(language);
    sessionStorage.setItem('locale', language);
    window.location.reload();
  }
  // bilangual end

  // FOR SET THEME AND TOGGLE THEME AND FONT CLASS - STARTS (Added By Vishal)
  setTheme(themeName: any) {
    localStorage.setItem('theme', themeName);
    if (window.sessionStorage.getItem('locale') == 'English') {
      document.documentElement.className = `${themeName} english-font`;
    } else {
      document.documentElement.className = `${themeName} hindi-font`;
    }
  }
  setThemeColor(themeName: any) {
    localStorage.setItem('themeColor', themeName);
    if (window.sessionStorage.getItem('locale') == 'English') {
      document.documentElement.className = `${themeName} english-font`;
    } else {
      document.documentElement.className = `${themeName} hindi-font`;
    }
  }


  // FOR SET THEME AND TOGGLE THEME - ENDS

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);

    if (element) {
      element.classList.add('scroll-target');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  toggleDarkTheme(): void {
    // document.body.classList.toggle('theme-dark');
    if (localStorage.getItem('theme') === 'theme-dark') {
      this.setTheme('theme-light');
      this.setThemeColor('theme-dark');
      $('.logo-dark').show();
      $('.logo-light').hide();
    } else {
      this.setTheme('theme-dark');
      this.setThemeColor('theme-light');
      $('.logo-light').show();
      $('.logo-dark').hide();
    }
    window.location.reload();
  }



  
  // language: any = 'English';
  browserLang: any;
  hasSubmenu: any;
  subMenuLength: any;
  logotitle: any;
  websitedetails: any;
  logoimg: any;





  // for hiding elements on scroll
  scroll(e: any) {
    const widthScreen = e;
    $(window).scroll(function () {
      var scrollTop = $(window).scrollTop();

      if (scrollTop > 0) {
        $('.hide-on-scroll').hide();
      }
      if (scrollTop == 0) {
        $('.hide-on-scroll').show();
      }

    });

  }


 



  headerGlobalMenu: any[] = [];
  headerPrimaryMenu: any[] = [];
  getallHeaderMenu():boolean {
    this.headerGlobalMenu = [];
    this.headerPrimaryMenu = [];
    let allmenu:any = this.fciwebservice.getFilterMenus(1);
    if(allmenu.length <= 0){
      return false;
    }
    for (let loop of allmenu) {
      if (loop["menuType"] == 1) //Global Menu
      {
        this.headerGlobalMenu.push(loop);
      } else if (loop["menuType"] == 2) { //Secondary Menu
        this.headerPrimaryMenu.push(loop);
      }
    }
    return true;
  }



  goToContentPage(primaryHeader: any) {
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate(['./view' + '/' + primaryHeader["menuAlias"]]));
  }


  goToExtLink(url: any) {
    Swal.fire({
      title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  } 

  goToPluginPage(link: any, menudtl: any) {
    sessionStorage.removeItem(btoa(menudtl.selectPlugin));
    sessionStorage.setItem(btoa(menudtl.selectPlugin), JSON.stringify(menudtl));
    // this.route.navigate([link,""]);
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate([link]));
  }

  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }


  GotoGlobalSearch(v: any) {
    if (v.value !== "") {
      // this.route.navigate(['/contentsearch',""]);
      // this.route.navigateByUrl(`/contentsearch?search=${v.value}`);
      // window.location.href = `/contentsearch?search=${v.value}`;
      window.localStorage.setItem('search_key', v.value);
      window.location.href = `${environment.siteURL}contentsearch`;
    }
  }
 
  zoneRegionList: any = [];
  getZoneRegionName() {
    this.zoneRegionList = [];
    let alldata:any = this.fciwebservice.ZoneRegionNameData();
    this.zoneRegionList = alldata.data;
  }

}
